import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { SharedService } from './shared.service';
import { TranslateModule } from "@ngx-translate/core";

import { CutUserNamePipe, GetProgress, RoleName, UserClassName, UrlImage, shoppingCarType, notificationsDate, messageDate, categoryName, CssChildHeight, CourseConfigUrl, GroupNamePipe, ImageUrlPipe, GetCategoryLogoPipe } from './shared.pipe';
import { ClickOutsideDdownDirective } from './directives/clickOutsideDdown.directive';
import { RouterModule } from '@angular/router';
import { ComboboxComponent } from './components/combobox/combobox.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { CustomImageComponent } from './components/custom-image/custom-image.component';
import { MenuComponent } from '../affiliates/components/menu/menu.component';
import { GetWebsiteUrlPipe, InAffiliatesPipe } from '../affiliates/pipes/affiliates.pipe';
import { InputNumberComponent } from './components/input-number/input-number.component';
import { TooltipDirective } from './directives/toolTip.directive';
import { CourseCardComponent } from '../affiliates/components/shared/course-card/course-card.component';
import { PopUpsComponent } from './components/pop-ups/pop-ups.component';
import { SharedAfilliatesModule } from '@app/affiliates/components/shared/shared.module';
import { GeneralModalComponent } from '@app/affiliates/components/shared/general-modal/general-modal.component';

@NgModule({
  declarations: [
    CutUserNamePipe, GetProgress, RoleName, UserClassName, UrlImage, shoppingCarType, notificationsDate, messageDate, categoryName, GroupNamePipe, CssChildHeight, CourseConfigUrl,
    ClickOutsideDdownDirective,
    ComboboxComponent,
    SearchBarComponent,
    CustomImageComponent,
    MenuComponent,
    InAffiliatesPipe,
    InputNumberComponent,
    TooltipDirective,
    PopUpsComponent,
    ImageUrlPipe,
  ],
  imports: [
    GetCategoryLogoPipe,
    GetWebsiteUrlPipe,
    FormsModule,
    CommonModule,
    RouterModule,
    TranslateModule,
  ],
  exports: [
    ClickOutsideDdownDirective,
    categoryName, CssChildHeight, RoleName,CourseConfigUrl, GroupNamePipe, UrlImage,
    ComboboxComponent,
    SearchBarComponent,
    CustomImageComponent,
    InputNumberComponent,
    TooltipDirective,
    PopUpsComponent,
    ImageUrlPipe,
    CutUserNamePipe,
    MenuComponent,
    UserClassName,
    TranslateModule,
  ],
  providers: [
    SharedService
  ]
})
export class SharedModule { }
